fx.ns("desktop.common.panels", class BackgroundsPanel extends fx.components.VBox
{   
	constructor(model)
	{
		super();
	
		this.model = model;
		this.data = model.backgrounds
		this.creation = model.creation;

		this.listenUpdates(this.creation);
		
		this._onSearchUpdatedHandler = this._onSearchUpdated.bind(this);
	}

	get data()
	{
		return super.data;
	}

	set data(val)
	{
		if (val instanceof fx.ModelArray)
			super.data = val;
		else
		if (val)
		{
			this.model = val;
			this.data = val.backgrounds
			this.creation = val.book;
		}

		if (this.grid && val)
			this.grid.data = val;
	}

	get book()
	{
		return this._book;
	}

	set book(val)
	{
		this._book = val;
	}

	get visible()
	{
		return super.visible;
	}

	set visible(val)
	{
		super.visible = val;

		if (val && this._toRefresh && this.grid)
		{
			this.grid.refresh();
			this._toRefresh = false;
		}
	}

	set renderers(val)
	{
		if (this.grid)
			this.grid.renderers = val;
	}

    create()
	{
		super.create();

		this.backgroundFilter = new filters.BackgroundFilter();

		this.search = new fx.components.SearchInput({placeHolder : fx.text("Rechercher"), propositions : this.data.categories});

		let box = new fx.components.Box("colors");
		this.colorPicker = new fx.components.ColorPickerButton({label : fx.text("Couleur"), lastColors : (this.model && this.model.customcolors) ? this.model.customcolors : null, pickerType : "backgrounds"});
		this.lastColors = new shared.panels.LastColors( (this.model && this.model.customcolors) ? this.model.customcolors : null );
		box.addChild( this.colorPicker, {width:105, height:55, left : 0});
		box.addChild( this.lastColors, {width:235, height:55, left : 105});
		
		this.grid = new fx.components.VerticalGridDynamic({ data : this.data,
															filter : this.backgroundFilter, 
															maxElementsPerRow : 2,
															maxRowHeight : 150,
															tilesSameSize : true,
															renderers : { Background : shared.renderers.BackgroundRenderer } } );
		
		this.addChild(this.search, {width:"100%"});
		this.addChild(box, {width:"100%", height:55});
		this.addChild(this.grid, {height:"fill", width:"100%"});
	}


	onReady()
	{
		super.onReady();

		this.on("updated", this.onSearchUpdated, this.search);
		this.on("selected", this.onSelected, this.search);
		this.on("enter", this.onSelected, this.search);

		this.on("more", this.onMore, this.grid);
		
		this.on("color", this.onColor, this.colorPicker);

		this.on("color", this.onColor, this.lastColors);

		this.on("loaded", this._onLoaded, this.data);

        this.on( "color-all", this.onColorSelectedApplyAll, this.colorPicker)

        // TODO : check this out
		//this.data.bookid = this.creation.id;
		//this.data.themeid = this.creation.themeid;
	}

	
	destroy() 
	{
		super.destroy();

		this.search = null;
		this.grid = null;
		this.backgroundFilter = null;
	}

    

	onSearchUpdated(e)
	{
		this.delay(this._onSearchUpdatedDelayed, 250);
	}

	_onSearchUpdatedDelayed()
	{
		this.backgroundFilter.search = "";
		
		if (this.search.value != "")
		{
			this.search.waiting = true;
			this.data.searchTags( this.search.value, this._onSearchUpdatedHandler );
		}
		else
		{
			this.data.search(false);
			this.search.results = [];
		}
	}


	onDataUpdated(action)
	{
		super.onDataUpdated(action);

		/*if (this.initialized && action.type == "init")
		{
			this.search.value = "";
			this.backgroundFilter.search = "";
			this.data.search(false);		
		}*/
	}

	_onSearchUpdated(results)
	{
		this.search.waiting = false;
		this.search.results = results;
	}

	onSelected(e)
	{
		this.grid.loading(true);
		this.grid.scrollTop();
		
		this.backgroundFilter.search = 	this.search.value;

		if (this.search.value != "")
			this.data.search( this.search.value );
		else
			this.data.search(false);

		
	}

	_onLoaded()
	{
		this.grid.loading(false);
	}

	onColor(e)
	{
		this.creation.event("update-background-color", e.detail);

		this.model.customcolors.addColor( e.detail, this.creation.id );
	}

    onColorSelectedApplyAll(e)
    {
        this.creation.event("update-background-color-all", e.detail);
        this.model.customcolors.addColor( e.detail, this.creation.id );
    }

	onMore()
	{
		this.data.loadMore(this.creation);
	}

});
